import script from "./EditRegisterContact.vue?vue&type=script&setup=true&lang=js"
export * from "./EditRegisterContact.vue?vue&type=script&setup=true&lang=js"

import "./EditRegisterContact.vue?vue&type=style&index=0&id=047bfaae&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-047bfaae"]])

export default __exports__